<template>
  <div class="home-page">
    <!-- 搜索 -->
    <SearchCard></SearchCard>
    <!-- 轮播图 -->
    <section class="hero-section">
      <el-carousel
        height="500px"
        :interval="5000"
        arrow="always"
        indicator-position="outside"
      >
        <el-carousel-item v-for="(banner, index) in banners" :key="index">
          <div class="banner-container">
            <div class="banner-img-box">
              <img
                :src="banner.image"
                :alt="banner.title"
                class="banner-image"
              />
            </div>
            <div class="banner-content">
              <h1 class="banner-title">{{ banner.title }}</h1>
              <p class="banner-description">{{ banner.description }}</p>
              <el-button
                type="primary"
                size="large"
                @click="handleBannerClick(banner)"
              >
                {{ banner.buttonText || "了解更多" }}
              </el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 产品分类 -->
    <section class="categories-section">
      <div class="container">
        <h2 class="section-title">产品分类</h2>
        <div class="categories-grid">
          <div
            v-for="category in categories"
            :key="category.id"
            class="category-card"
            @click="goToCategory(category)"
          >
            <div class="category-icon">
              <img
                :src="category.image"
                :alt="category.name"
                class="banner-image"
              />
            </div>
            <h3 class="category-name">{{ category.name }}</h3>
            <p class="category-desc">{{ category.description }}</p>
            <div class="category-count">{{ category.count }}个产品</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 推荐产品 -->
    <section class="featured-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">热销产品</h2>
          <router-link to="/category" class="view-all">
            查看全部
            <el-icon><ArrowRight /></el-icon>
          </router-link>
        </div>
        <div class="products-grid">
          <ProductCard
            v-for="product in featuredProducts"
            :key="product.id"
            :product="product"
            @add-to-cart="handleAddToCart"
            @quick-view="handleQuickView"
          />
        </div>
      </div>
    </section>

    <!-- 特色服务 -->
    <section class="services-section">
      <div class="container">
        <h2 class="section-title">我们的服务</h2>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">
              <el-icon><Medal /></el-icon>
            </div>
            <h3>高品质保证</h3>
            <p>严格的质量控制体系，确保产品质量</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <el-icon><Headset /></el-icon>
            </div>
            <h3>专业技术支持</h3>
            <p>专业的售前售后技术支持团队</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <el-icon><Ship /></el-icon>
            </div>
            <h3>快速物流</h3>
            <p>覆盖全国的物流网络，快速响应</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <el-icon><Document /></el-icon>
            </div>
            <h3>完整方案</h3>
            <p>提供完整的实验方案和技术文档</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 热门品牌 -->
    <section class="brands-section" ref="scrollContainer">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="brands-grid">
          <div class="mes-box">
            <el-icon><ChatRound /></el-icon>
            <div>
              <img :src="wxIng" alt="" />
            </div>
          </div>
          <div class="mes-box">
            <el-icon class="phone-outline">
              <Phone />
            </el-icon>
            <span class="text">13166409925</span>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部 -->
    <div class="footer">
      <span>
        沪ICP备<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">2025152670</a>号
      </span>
    </div>
    <!-- 快速查看弹窗 -->
    <el-dialog
      v-model="showQuickView"
      title="产品详情"
      width="800px"
      destroy-on-close
    >
      <QuickView
        v-if="selectedProduct"
        :product="selectedProduct"
        @add-to-cart="handleAddToCart"
      />
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted , nextTick,watch  } from "vue";
import { useRoute } from 'vue-router';
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import ProductCard from "../components/common/ProductCard.vue";
import SearchCard from "../components/common/Search.vue";
import QuickView from "../components/product/QuickView.vue";
// import { getFeaturedProducts } from 'src/api/products'
// import { useCartStore } from 'src/stores/cart'
import type { Product, ProductCategory } from "@/types/product";
import { Search } from "@element-plus/icons-vue";
import {
  banner,
  category,
  elisa_imgs_obj,
  sh_imgs_obj,
  elisaFunc,
  shFunc,
  wxIng,
} from "../utils/home_util.js";
const router = useRouter();
const route = useRoute();
// const cartStore = useCartStore()
const scrollContainer = ref(null);
// 轮播图数据
const banners = ref(banner);

// 产品分类
const categories = ref([category[1],category[2]]);

// 推荐产品
const featuredProducts = ref([]);

// 品牌
const brands = ref([
  { id: 1, name: "Brand 1", logo: "https://via.placeholder.com/150x80" },
  { id: 2, name: "Brand 2", logo: "https://via.placeholder.com/150x80" },
  { id: 3, name: "Brand 3", logo: "https://via.placeholder.com/150x80" },
  { id: 4, name: "Brand 4", logo: "https://via.placeholder.com/150x80" },
  { id: 5, name: "Brand 5", logo: "https://via.placeholder.com/150x80" },
  { id: 6, name: "Brand 6", logo: "https://via.placeholder.com/150x80" },
]);
// 平滑滚动版本
const smoothScrollToBottom = () => {
  if (scrollContainer.value) {
    nextTick(() => {
      scrollContainer.value.scrollTo({
        top: scrollContainer.value.scrollHeight,
        behavior: 'smooth'
      });
    });
  }
};
// 监听路由查询参数变化
watch(
  () => route.query,
  (from,to) => {
    console.log(from,'from')
    // if (from === 'category') {
    //   nextTick(() => {
    //     smoothScrollToBottom();
    //   });
    // }
  },
  { immediate: true }
);
// 快速查看状态
const showQuickView = ref(false);
const selectedProduct = ref(null);

// 加载推荐产品
const loadFeaturedProducts = async () => {
  let arr1 = elisaFunc().map((item) => {
    return {
      ...item,
      category: "ELISA",
      image: elisa_imgs_obj()[0],
      proNum: item.proNum,
      spec: item.spec,
      originalPrice: "¥1,500-¥3,000",
    };
  });
  let arr2 = shFunc().map((item) => {
    return {
      ...item,
      category: "SH",
      image: sh_imgs_obj()[0],
      proNum: item.proNum,
      spec: item.spec,
      originalPrice:item.price + 100
    };
  });
  featuredProducts.value = [arr1[0], arr1[1], arr2[0], arr2[1]];
  // try {
  //   const response = await getFeaturedProducts({ limit: 8 })
  //   featuredProducts.value = response.data
  // } catch (error) {
  //   console.error('加载推荐产品失败:', error)
  //   // 使用模拟数据
  //   featuredProducts.value = generateMockProducts()
  // }
};

// 事件处理
const handleBannerClick = (banner: any) => {
  router.push(banner.link);
};

const goToCategory = (category: ProductCategory) => {
  router.push({
    path: "/category",
    query: { type: category.slug },
  });
};

// const handleAddToCart = (product: Product) => {
//   cartStore.addItem({
//     productId: product.id,
//     product,
//     quantity: 1,
//   });
//   ElMessage.success("已添加到购物车");
// };

const handleQuickView = (product: Product) => {
  selectedProduct.value = product;
  showQuickView.value = true;
};

onMounted(() => {
  loadFeaturedProducts();
});
</script>

<style scoped lang="scss">

.home-page {
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
  }
}

.hero-section {
  .banner-container {
    position: relative;
    height: 100%;
    .banner-img-box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .banner-image {
        width: 400px;
        height: 400px;
      }
    }
  }

  .banner-content {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translateY(-50%);
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    max-width: 600px;

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      margin-bottom: 20px;
      line-height: 1.2;
    }

    .banner-description {
      font-size: 18px;
      margin-bottom: 30px;
      line-height: 1.6;
    }
  }
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  color: var(--el-text-color-primary);
  text-align: center;
  margin-bottom: 48px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: var(--el-color-primary);
  }
}

.categories-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);

  .categories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 32px;
    margin-top: 48px;
  }

  .category-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: var(--el-box-shadow-light);

    &:hover {
      transform: translateY(-8px);
      box-shadow: var(--el-box-shadow);
    }

    .category-icon {
      font-size: 48px;
      color: var(--el-color-primary);
      margin-bottom: 20px;
      img {
        width: 300px;
        height: 300px;
      }
    }

    .category-name {
      font-size: 20px;
      font-weight: bold;
      color: var(--el-text-color-primary);
      margin-bottom: 12px;
    }

    .category-desc {
      color: var(--el-text-color-secondary);
      margin-bottom: 16px;
      line-height: 1.6;
    }

    .category-count {
      font-size: 14px;
      color: var(--el-color-primary);
      font-weight: 500;
    }
  }
}

.featured-section {
  padding: 80px 0;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
  }

  .view-all {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--el-color-primary);
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  .products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    cursor: pointer;
  }
}

.services-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);

  .services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 32px;
    margin-top: 48px;
  }

  .service-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    text-align: center;
    box-shadow: var(--el-box-shadow-light);

    .service-icon {
      font-size: 48px;
      color: var(--el-color-primary);
      margin-bottom: 20px;
    }

    h3 {
      font-size: 18px;
      font-weight: bold;
      color: var(--el-text-color-primary);
      margin-bottom: 12px;
    }

    p {
      color: var(--el-text-color-secondary);
      line-height: 1.6;
    }
  }
}

.brands-section {
  padding: 80px 0;

  .brands-grid {
    display: flex;
    justify-content: space-evenly;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 40px;
    margin-top: 48px;
    .mes-box {
      font-size: 50px;
      display: flex;
      justify-items: center;
      align-items: center;
      img {
        width: 200px;
      }
    }
    .brand-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
      background: white;
      border-radius: 8px;
      padding: 20px;
      box-shadow: var(--el-box-shadow-light);

      img {
        max-width: 100%;
        max-height: 60px;
        object-fit: contain;
        filter: grayscale(100%);
        transition: filter 0.3s ease;

        &:hover {
          filter: grayscale(0);
        }
      }
    }
  }
}
.footer{
  margin: 0;
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 60px;
  background: #000;
  color: #f8fafc;
  a{
    color: #00f;
  }
}
@media (max-width: 768px) {
  .hero-section {
    .banner-content {
      .banner-title {
        font-size: 32px;
      }

      .banner-description {
        font-size: 16px;
      }
    }
  }

  .section-title {
    font-size: 24px;
  }

  .categories-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>